/* tslint:disable */
/* eslint-disable */
export enum DriverLookupResultEnum {
  DriverNotFound = 0,
  DriverNotOnCarrier = 1,
  DriverFoundOnCarrier = 2,
}
